import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

function SimpleDialog({ open, onClose, errorMessage }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Invalid Resumes</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The following resumes could not be uploaded:
        </DialogContentText>
        <List>
          {errorMessage?.map((item, index) => (
            <ListItem key={index}>
              <ListItemText primary={item?.fileName || "Unnamed File"} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default SimpleDialog;
